import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

export class MultiSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: Array.isArray(props.checked) ? props.checked : [],
      dropDownValue: props.options || [],
    };
  }

  async componentWillReceiveProps(nextProps) {
    await this.setState({
      dropDownValue: nextProps.options,
      checked: Array.isArray(nextProps.checked) ? nextProps.checked : [],
    });
  }

  checkBox = (value, condition) => {
    const { checked } = this.state;
    const checkedValue = [...checked]; // clone the checked array
    if (condition) {
      if (!checkedValue.includes(value)) {
        checkedValue.push(value);
      }
    } else {
      const index = checkedValue.indexOf(value);
      if (index > -1) {
        checkedValue.splice(index, 1);
      }
    }
    this.setState({
      checked: checkedValue,
    }, () => {
      if (this.props.onSelectOptions) this.props.onSelectOptions(this.state.checked);
    });
  }

  removeChip = (value) => {
    this.checkBox(value, false);
  }

  searchFun = async (e) => {
    const { options } = this.props;
    if (e.target.value.length !== 0) {
      const enteredValue = e.target.value.toLowerCase();
      const presentValue = options.filter(data => data.name.toLowerCase().includes(enteredValue));
      await this.setState({ dropDownValue: presentValue });
    } else {
      await this.setState({ dropDownValue: options });
    }
  }

  returnChip = () => (this.state.checked.map((data, index) => {
    const selectedContract = this.props.options.find(item => item.value === data);
    if (selectedContract) {
      return (
        <div className="chip-body" key={index.toString()}>
          <p className="chip-text">{selectedContract.name}</p>
          {!this.props.disabled && (
            <button
              type="button"
              className="chip-close"
              onClick={() => this.removeChip(data)}
            >
              &times;
            </button>
          )}
        </div>
      );
    }
    return null;
  }))

  returnList = () => (this.state.dropDownValue ? this.state.dropDownValue.map((data, index) => (
    <label className="container" key={index.toString()}>
      {data.name}
      <input
        type="checkbox"
        value={data.value}
        onChange={e => this.checkBox(e.target.value, e.target.checked)}
        checked={this.state.checked.includes(data.value)}
      />
      <span className="checkmark" />
    </label>
  )) : null)

  render() {
    return (
      <div className="multiSelect">
        <div className="chip">
          {this.returnChip()}
        </div>
        <input
          type="text"
          name="Search"
          placeholder=""
          className="input-box form-control"
          onChange={this.searchFun}
          disabled={this.props.disabled}
        />
        <div className="search-result">
          <div className="list-result">
            {this.returnList()}
          </div>
        </div>
      </div>
    );
  }
}

MultiSelect.defaultProps = {
  options: [],
};

/** define proptypes including fields which is required */
MultiSelect.propTypes = {
  options: PropTypes.array.isRequired,
  checked: PropTypes.array,
  onSelectOptions: PropTypes.func,
  disabled: PropTypes.bool,
};

export default MultiSelect;
